export default __webpack_public_path__ + "static/media/mail.dbfc449b.svg";